import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef, useState } from 'react';
import { Disclosure } from '@headlessui/react';
import { ChevronRightIcon } from '@heroicons/react/24/solid';
import { twMerge } from 'tailwind-merge';
export function useAccordionTransition(isOpen, duration = 200) {
    const [height, setHeight] = useState(isOpen ? 'auto' : '0');
    const ref = useRef(null);
    useEffect(() => {
        const element = ref.current;
        if (!element)
            return;
        if (isOpen) {
            // Open transition
            setHeight(`${element.scrollHeight}px`);
            setTimeout(() => {
                // Transition to 'auto' after opening
                setHeight('auto');
            }, duration);
        }
        else {
            // Close transition
            // Set height to current scrollHeight before closing
            setHeight(`${element.scrollHeight}px`);
            // Start transition to '0' after a short delay
            setTimeout(() => {
                setHeight('0');
            }, 10);
        }
    }, [isOpen, duration]);
    return { ref, style: { height, overflow: 'hidden', transition: `height ${duration}ms ease` } };
}
export const Accordion = ({ children, title, variant = 'default', className = '', buttonClassName = '', panelClassName = '', controlOpen, chevronOptions = {
    hide: false,
    position: 'right',
}, }) => {
    return (_jsx(Disclosure, { children: ({ open: disclosureOpen }) => {
            // eslint-disable-next-line react-hooks/rules-of-hooks
            const { ref, style } = useAccordionTransition(controlOpen ? controlOpen.open : disclosureOpen);
            return (
            /* Use the `open` state to conditionally change the direction of an icon. */
            _jsxs("div", { className: twMerge(`flex flex-col rounded bg-transparent ${className}`), children: [_jsxs(Disclosure.Button, { className: twMerge(variant === 'default'
                            ? `relative z-[1] flex items-center justify-between bg-slate-100 px-4 py-3 focus:outline-none`
                            : 'relative inline-flex min-h-7 items-center justify-start gap-2 border-b border-black border-opacity-10 px-2 py-1', controlOpen ? (controlOpen.open ? 'rounded-t' : 'rounded-t') : '', buttonClassName), onClick: () => {
                            if (controlOpen) {
                                controlOpen.onClick(controlOpen.open);
                            }
                        }, children: [!chevronOptions.hide && chevronOptions.position === 'left' && (_jsx(ChevronRightIcon, { className: `${variant === 'minimal' ? 'size-3' : 'size-6'} transform transition-transform duration-200 ease-out ${(controlOpen ? controlOpen.open : disclosureOpen) ? 'rotate-90' : ''}` })), typeof title === 'string' ? (_jsx("span", { className: variant === 'default'
                                    ? ''
                                    : 'text-xs font-semibold uppercase leading-tight tracking-wide text-gray-600', children: title })) : (title), !chevronOptions.hide && chevronOptions.position === 'right' && (_jsx(ChevronRightIcon, { className: `${variant === 'minimal' ? 'size-3' : 'size-6'} transform transition-transform duration-200 ease-out ${(controlOpen ? controlOpen.open : disclosureOpen) ? 'rotate-90' : ''}` }))] }), _jsx("div", { ref: ref, style: style, children: _jsx(Disclosure.Panel, { static: true, className: twMerge(variant === 'default' ? `rounded-b border border-gray-200 border-t-transparent` : '', panelClassName), children: children }) })] }));
        } }));
};
//# sourceMappingURL=Accordion.js.map